export default __webpack_public_path__ + "static/media/logo-lettre.14c5eafa.svg";